import { observer } from 'mobx-react-lite';
import React from 'react';
import { AppState, EmailTableCol, updateSorting } from '../stores/appStateStore';

interface TableHeaderProps {
    state: AppState,
    column: EmailTableCol,
    ref?: React.MutableRefObject<HTMLTableCellElement|null>|React.ForwardRefExoticComponent<React.RefAttributes<unknown>> 
}

const TABLE_HEADER_NAMES: Record<EmailTableCol, string> = {
    subject: 'Subject',
    from: 'From',
    to: 'To',
    date: 'Date (UTC)',
    size: 'Size',
    none: 'None'
};

const TableHeader = observer(React.forwardRef((props: TableHeaderProps, ref: React.ForwardedRef<any>) => {
    const {state, column} = props;
    const colMatch: boolean = (column === state.sorting.column);
    let iconClass;
    if(colMatch) {
        if(state.sorting.direction === 'asc') {
            iconClass = 'arrow-up ';
        } else {
            iconClass = 'arrow-down ';
        }
    }
    if(ref !== null) {
        return (
            <div className='flex-mother table-header'>
                <div className={'flex-1 flex-mother-col' + (colMatch?' active-col':'')} onClick={() => {updateSorting(state, column);}}>
                    <div className="flex-1"/>
                    <span>{TABLE_HEADER_NAMES[column]}{colMatch?<i className={iconClass+'ml-1em'}/>:''}</span>
                    <div className="flex-1"/>
                </div>
                <span className="table-col-resize-handle" ref={ref}/>
            </div>
        );
    }
    return (
        <div className='flex-mother table-header'>
            <div className={'flex-1 flex-mother-col table-col-handle-height-only' + (colMatch?' active-col':'')} onClick={() => {updateSorting(state, column);}}>
                <div className="flex-1"/>
                <span>{TABLE_HEADER_NAMES[column]}{colMatch?<i className={iconClass+'ml-1em'}/>:''}</span>
                <div className="flex-1"/>
            </div>
        </div>
    );
}));

export default TableHeader;